<div class="card">

    <div class="header-section">
        <!-- <div class="action">
            <button pButton label="Save" icon="pi pi-save" class="p-button-primary" (click)="saveDefaults()">
            </button>
            <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger" size="small"
                (onClick)="onCancel()">
            </p-button>
        </div> -->
        <div class="action action-buttons">
            <!-- Save Button -->
            <button pButton type="button" label="Save" icon="pi pi-save" class="p-button-primary"
                (click)="saveDefaults()">
            </button>

            <!-- Cancel Button -->
            <button pButton type="button" label="Cancel" icon="pi pi-times" class="p-button-outlined p-button-danger"
                (click)="onCancel()">
            </button>

        </div>

    </div>

    <p-table [value]="departmentDefaults" responsiveLayout="scroll" class="p-datatable-sm" [paginator]="true"
        [rows]="10" [rowsPerPageOptions]="[5,10,20,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

        <ng-template pTemplate="header">
            <tr>
                <th>Transaction Type</th>
                <th>Department</th>
                <th>Department Name</th>
                <th>Effective From</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
            <tr>
                <td>{{ row.transactionType }}</td>

                <td>
                    <p-dropdown [options]="departments" optionLabel="name" optionValue="departmentId"
                        (onChange)="onDepartmentChange(row)" [(ngModel)]="row.departmentId" appendTo="body"
                        placeholder="Select Department" [filter]="true" [showClear]="true">

                        <ng-template pTemplate="item" let-dept>
                            {{ dept.code }} - {{ dept.name }}
                        </ng-template>

                        <ng-template pTemplate="selectedItem" let-dept>
                            {{ dept?.code }} - {{ dept?.name }}
                        </ng-template>

                    </p-dropdown>
                </td>

                <td>{{ departmentMap[row.departmentId]?.name }}</td>

                <td>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [(ngModel)]="row.effectiveFrom" dateFormat="dd/mm/yy" [showIcon]="true"
                            appendTo="body">
                        </p-calendar>
                    </div>
                </td>

            </tr>
        </ng-template>

    </p-table>
</div>
<p-toast></p-toast>